import { Star, Quote } from "lucide-react";

const items = [
  { quote: "Sábado de casa cheia, ninguém dava conta do WhatsApp. A IA respondeu 23 pedidos sozinha enquanto a gente tocava o salão. Salvou meu fim de semana.", name: "Marcos Vieira", biz: "Pizzaria Forno Velho — Montes Claros, MG", color: "bg-brutal-pink", rotate: "lg:-rotate-1" },
  { quote: "Minha mãe tem 62 anos e cuida do caixa. Em dois dias ela já estava fechando mesa pelo sistema sem pedir ajuda. Isso pra mim disse tudo.", name: "Juliana Castro", biz: "Sabor da Roça — Pirapora, MG", color: "bg-brutal-lime", rotate: "lg:rotate-1" },
  { quote: "Antes era comanda de papel, item esquecido e briga com a cozinha. Hoje o pedido sai na impressora na hora e o erro praticamente acabou.", name: "André Luz", biz: "Hamburgueria do Luz — Bocaiúva, MG", color: "bg-brutal-sky", rotate: "lg:-rotate-1" },
];

export const Testimonials = () => (
  <section data-testid="testimonials" className="relative py-24 sm:py-32 bg-brutal-cream">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
      <div className="max-w-2xl">
        <div className="inline-flex items-center gap-2 bg-brutal-pink border-[2.5px] border-brutal-black px-3.5 py-1.5 shadow-brutal-xs">
          <Star size={14} strokeWidth={3} fill="currentColor" className="text-white" />
          <span className="font-mono text-[11px] font-bold uppercase tracking-widest text-white">QUEM USA, RECOMENDA</span>
        </div>
        <h2 className="mt-5 font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight text-brutal-black uppercase leading-[0.95]">
          Histórias de quem<br />
          <span className="bg-brutal-lime border-[3px] border-brutal-black px-3 inline-block shadow-brutal -rotate-1 mt-2">parou de perder pedido</span>
        </h2>
      </div>
      <div className="mt-16 grid md:grid-cols-3 gap-7 sm:gap-8">
        {items.map((t) => (
          <figure key={t.name} data-testid={`testimonial-${t.name.split(" ")[0].toLowerCase()}`} className={`relative bg-white border-[3px] border-brutal-black p-7 shadow-brutal-lg hover:translate-y-[-4px] hover:shadow-brutal-xl transition-all flex flex-col ${t.rotate}`}>
            <div className={`absolute -top-5 -right-3 inline-flex items-center justify-center w-12 h-12 border-[3px] border-brutal-black ${t.color} shadow-brutal-sm`}>
              <Quote size={20} strokeWidth={3} className="text-brutal-black" fill="currentColor" />
            </div>
            <div className="flex gap-0.5 text-brutal-black">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={18} fill="#FFEC3D" strokeWidth={2} className="text-brutal-black" />
              ))}
            </div>
            <blockquote className="mt-5 text-brutal-black leading-relaxed flex-1 font-medium text-[15px]">"{t.quote}"</blockquote>
            <figcaption className="mt-6 pt-5 border-t-[2.5px] border-brutal-black border-dashed">
              <p className="font-heading text-base text-brutal-black uppercase leading-tight">{t.name}</p>
              <p className="font-mono text-[11px] uppercase tracking-wider text-brutal-black/70 mt-1 font-medium">{t.biz}</p>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);
